import { employeeProfileEdit } from "../../../../i18n/translatedMessages";

export const Family = ({ onChange, data, error, lists }) => {
  return (
    <div className="content-form">
      <div className="row">
        <div className="col">
          <h3>Informaciones Familiar</h3>
        </div>
      </div>
      <div className="row">
        <div className={`col ${error.gender ? "error-radio" : ""}`}>
          <div className="label">Genero</div>
          <div className="radio-group">
            {lists?.gender?.map((item) => (
              <div key={item.id}>
                <input type="radio" onChange={onChange} value={item.id} name="gender" id={item.name} checked={item.id === data.gender} />{" "}
                <label htmlFor={item.name}>{item.name}</label>
              </div>
            ))}
          </div>
          {error.gender && <small>{employeeProfileEdit.profileError}</small>}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="label">Estado Civil</div>
          <div className="radio-group">
            {lists?.maritalStatus?.map((item) => (
              <div key={item.id}>
                <input type="radio" onChange={onChange} value={item.id} name="civil_status" id={item.name} checked={item.id === data.civil_status ? true : false} />
                <label htmlFor={item.name}>{item.name}</label>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <label htmlFor="Children">Composición familiar</label>
          <input type="text" name="family_composition" id="Children" onChange={onChange} value={data.family_composition || ""} />
        </div>
      </div>
    </div>
  );
};
